import { render, staticRenderFns } from "./QRCodePage.vue?vue&type=template&id=816a9cba&scoped=true&"
import script from "./QRCodePage.vue?vue&type=script&lang=js&"
export * from "./QRCodePage.vue?vue&type=script&lang=js&"
import style0 from "./QRCodePage.vue?vue&type=style&index=0&id=816a9cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a9cba",
  null
  
)

export default component.exports